/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createLayout,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

export const userBoardLayout: Layout = createLayout();
